import React, { Fragment, useMemo, useState } from 'react'
import { Dashboard } from '../../../components/ExportImgFigma'
import { DatePicker, Tabs } from 'antd'
import '../styles.scss'

import ReactECharts from "echarts-for-react";
import { months } from 'moment'
import { TabsProps } from 'antd/lib'
import ServiceMaintenanceInvoice from './ServiceMaintenanceInvoice'
import VehicleInvoice from './VehicleInvoice'
import { formatCurrency } from '../../../services/mixin'

const InvoiceHistory = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  // tính dữ liệu cho chart
  const buyData = useMemo(() => {
    const arr = Array(12).fill(0);
    (stData.vehicle_owner_total_sale || []).forEach((val: any) => {
      const month = new Date(val.own_purchase_date).getMonth();
      arr[month] += 1;
    });
    return arr;
  }, [stData.vehicle_owner_total_sale]);

  const serviceData = useMemo(() => {
    const arr = Array(12).fill(0);
    (stData.vehicle_owner_total_service || []).forEach((val: any) => {
      const month = new Date(val.own_purchase_date).getMonth();
      arr[month] += 1;
    });
    return arr;
  }, [stData.vehicle_owner_total_service]);

  // chart
  const option = useMemo(() => ({
    title: '',
    tooltip: { trigger: "axis" },
    legend: {
      data: ["Hóa đơn mua xe", "Hóa đơn dịch vụ"],
      bottom: 0, // nằm dưới như bạn muốn
    },
    xAxis: { type: "category", data: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"] },
    yAxis: { type: "value" },
    series: [
      {
        name: "Hóa đơn mua xe",
        type: "bar",
        stack: "total",
        data: buyData,
        itemStyle: {
          color: {
            type: "linear", x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: "#3b82f6" },
              { offset: 1, color: "#93c5fd" }
            ]
          }
        }
      },
      {
        name: "Hóa đơn dịch vụ",
        type: "bar",
        stack: "total",
        data: serviceData,
        itemStyle: {
          color: {
            type: "linear", x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: "#f87171" },
              { offset: 1, color: "#fecaca" }
            ]
          }
        }
      }
    ]
  }), [buyData, serviceData]);

  const [year, setYear] = useState<number>(2025);

  const handleChangeYear = (date: any) => {
    if (date) setYear(date.year());
  };


  const onChange = (key: string) => {
    // setIsTab(Number(key));
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Hoá đơn xe</span>,
      children: <VehicleInvoice stData={stData} stChange={(data) => stChange(data)} />,
    },
    {
      key: '2',
      label: <span className='custom-page-css font-light text-lg'>Hoá đơn bảo trì dịch vụ</span>,
      children: <ServiceMaintenanceInvoice stData={stData} stChange={(data) => stChange(data)} />,
    },
  ];


  return (
    <Fragment>
      <div className='custom-page-css w-full pb-3 flex flex-col gap-3'>
        <div className="custom-page-css w-full flex gap-3">
          <div className="custom-page-css  flex flex-2 flex-col justify-around rounded border">
            <div className="custom-page-css w-full flex items-center justify-around gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center gap-3">
                <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                  <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                </div>
                <span className='custom-page-css text-xl font-light text-475467'>Tổng chi tiêu</span>
              </div>
              <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{formatCurrency(stData.total_order_amount + stData.total_service_amount)}</span>

            </div>
            <div className="custom-page-css px-2 flex flex-col justify-around">
              <div className="custom-page-css flex py-2 flex-1 border-b">
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 border-r">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{stData.vehicle_owner_total_sale?.length}</span>
                  <span className='custom-page-css text-xl font-light text-475467'>SL hóa đơn mua xe </span>
                </div>
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 ">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{stData.vehicle_owner_total_service?.length}</span>
                  <span className='custom-page-css text-xl font-light text-475467'>SL hóa đơn dịch vụ</span>
                </div>
              </div>
              <div className="custom-page-css flex py-2 flex-1 ">
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 border-r">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{formatCurrency(stData.total_order_amount)} </span>
                  <span className='custom-page-css text-xl font-light text-475467'>Hóa đơn mua xe </span>
                </div>
                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 ">
                  <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{formatCurrency(stData.total_service_amount)} </span>
                  <span className='custom-page-css text-xl font-light text-475467'>Hóa đơn dịch vụ</span>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-page-css  flex flex-5 flex-col rounded border">
            <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 16 }}>
              {/* Title + DatePicker cùng hàng */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <span className='custom-page-css font-bold  text-xl text-344054'>
                  Thống kê số lượng hóa đơn giao dịch trong năm
                </span>
              </div>

              {/* Chart */}
              <ReactECharts option={option} />
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />
        </div>



      </div>
    </Fragment>
  )
}
export default InvoiceHistory
